// extracted by mini-css-extract-plugin
export var dataCell = "_oq-2";
export var dataRow = "_oq-0";
export var headerRow = "_oq-1";